import { ReactComponent as YouTubeVerified } from "@svgr/webpack?-svgo,+titleProp,+ref!./YouTubeVerified.svg";
import { ReactComponent as RibbonDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./RibbonDefault.svg";
import { ReactComponent as RibbonVerified } from "@svgr/webpack?-svgo,+titleProp,+ref!./RibbonVerified.svg";
import { ReactComponent as RibbonUnverified } from "@svgr/webpack?-svgo,+titleProp,+ref!./RibbonUnverified.svg";
import { ReactComponent as FacebookVerified } from "@svgr/webpack?-svgo,+titleProp,+ref!./FacebookVerified.svg";
import { ReactComponent as InstagramVerified } from "@svgr/webpack?-svgo,+titleProp,+ref!./InstagramVerified.svg";
export const BadgeIcons = {
  YouTubeVerified,
  RibbonDefault,
  RibbonVerified,
  RibbonUnverified,
  FacebookVerified,
  InstagramVerified
};
export const BadgeIconNames = ["YouTubeVerified", "RibbonDefault", "RibbonVerified", "RibbonUnverified", "FacebookVerified", "InstagramVerified"];